import MuiButton, { type ButtonProps } from '@mui/material/Button'
import { type FC, type ReactNode } from 'react'

import Tooltip from '@/app/component/atom/tooltip'

type Props = ButtonProps & {
  tooltip?: ReactNode
}

const Button: FC<Props> = (props) => {
  const { tooltip, ...buttonProps } = props

  return (
    <Tooltip title={tooltip}>
      <span>
        <MuiButton {...buttonProps} />
      </span>
    </Tooltip>
  )
}

export default Button
